import { FEATURE_FLAGS, TFeatureFlag } from "./types";

export const FEATURE_FLAG_VALUES: FEATURE_FLAGS[] = [
  FEATURE_FLAGS.AUDIO_NOTES,
  FEATURE_FLAGS.ALLOW_ALL_USERS_TO_ADD_COMMENTS,
  FEATURE_FLAGS.DOCUMENTS,
  FEATURE_FLAGS.DOCUMENT_ACKNOWLEDGMENTS,
  FEATURE_FLAGS.JHA,
  FEATURE_FLAGS.CORRECTIVE_ACTIONS,
  FEATURE_FLAGS.FORMS,
  FEATURE_FLAGS.STANDARDS,
  FEATURE_FLAGS.CONTRACTOR_MANAGEMENT,
  FEATURE_FLAGS.EQUIPMENT_MANAGEMENT,
  FEATURE_FLAGS.TRAINING_CERT,
  FEATURE_FLAGS.SITE_MANAGEMENT,
  FEATURE_FLAGS.PEOPLE_MANAGEMENT,
  FEATURE_FLAGS.DIVISION_MANAGEMENT,
  FEATURE_FLAGS.TO_DO_LIST,
  FEATURE_FLAGS.PUBLIC_REGISTRATION,
  FEATURE_FLAGS.PUBLIC_SHARE_EQUIPMENT,
  FEATURE_FLAGS.PUBLIC_SHARE_CONTRACTORS,
  FEATURE_FLAGS.PUBLIC_SHARE_DOCUMENTS,
  FEATURE_FLAGS.PUBLIC_SHARE_JOBS,
  FEATURE_FLAGS.REPORTS,
  FEATURE_FLAGS.SYSTEM_EXPORT,
  FEATURE_FLAGS.DEV_ONLY,
  FEATURE_FLAGS.TASKS,
  FEATURE_FLAGS.QUEUES,
  FEATURE_FLAGS.NOTIFICATIONS,
  FEATURE_FLAGS.DOCUMENTS_OFFLINE,
  FEATURE_FLAGS.FORMS_OFFLINE,
  FEATURE_FLAGS.VIDEO_MANAGEMENT,
  FEATURE_FLAGS.DASHBOARD,
  FEATURE_FLAGS.SCHEDULER,
  FEATURE_FLAGS.LANGUAGE,
  FEATURE_FLAGS.NONLINEAR_WORKFLOW,
  FEATURE_FLAGS.WORKFLOW_ROUTING,
  FEATURE_FLAGS.NONLINEAR_TRAINING,
  FEATURE_FLAGS.PROJECT_MANAGEMENT,
  FEATURE_FLAGS.WEBHOOKS,
  FEATURE_FLAGS.PIN_MAP,
  FEATURE_FLAGS.CLIMATE_API,
  FEATURE_FLAGS.DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT,
  FEATURE_FLAGS.DISABLE_FORM_DUPLICATION,
];

export const SYSTEM_EXPORT: TFeatureFlag = {
  name: FEATURE_FLAGS.SYSTEM_EXPORT,
};

export const AUDIO_NOTES: TFeatureFlag = {
  name: FEATURE_FLAGS.AUDIO_NOTES,
};

export const DOCUMENTS: TFeatureFlag = {
  name: FEATURE_FLAGS.DOCUMENTS,
};

export const DOCUMENT_ACKNOWLEDGMENTS: TFeatureFlag = {
  name: FEATURE_FLAGS.DOCUMENT_ACKNOWLEDGMENTS,
};

export const JHA: TFeatureFlag = {
  name: FEATURE_FLAGS.JHA,
};

export const CORRECTIVE_ACTIONS: TFeatureFlag = {
  name: FEATURE_FLAGS.CORRECTIVE_ACTIONS,
};

export const FORMS: TFeatureFlag = {
  name: FEATURE_FLAGS.FORMS,
};

export const TASKS: TFeatureFlag = {
  name: FEATURE_FLAGS.TASKS,
};

export const STANDARDS: TFeatureFlag = {
  name: FEATURE_FLAGS.STANDARDS,
};

export const CONTRACTOR_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.CONTRACTOR_MANAGEMENT,
};

export const EQUIPMENT_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.EQUIPMENT_MANAGEMENT,
};

export const TRAINING_CERT: TFeatureFlag = {
  name: FEATURE_FLAGS.TRAINING_CERT,
};

export const SITE_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.SITE_MANAGEMENT,
};

export const PEOPLE_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.PEOPLE_MANAGEMENT,
};

export const DIVISION_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.DIVISION_MANAGEMENT,
};

export const TO_DO_LIST: TFeatureFlag = {
  name: FEATURE_FLAGS.TO_DO_LIST,
};

export const PUBLIC_REGISTRATION: TFeatureFlag = {
  name: FEATURE_FLAGS.PUBLIC_REGISTRATION,
};

export const PUBLIC_SHARE_EQUIPMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.PUBLIC_SHARE_EQUIPMENT,
};

export const PUBLIC_SHARE_CONTRACTORS: TFeatureFlag = {
  name: FEATURE_FLAGS.PUBLIC_SHARE_CONTRACTORS,
};

export const PUBLIC_SHARE_DOCUMENTS: TFeatureFlag = {
  name: FEATURE_FLAGS.PUBLIC_SHARE_DOCUMENTS,
};

export const PUBLIC_SHARE_JOBS: TFeatureFlag = {
  name: FEATURE_FLAGS.PUBLIC_SHARE_JOBS,
};

export const REPORTS: TFeatureFlag = {
  name: FEATURE_FLAGS.REPORTS,
};

export const DEV_ONLY: TFeatureFlag = {
  name: FEATURE_FLAGS.DEV_ONLY,
};

export const NOTIFICATIONS: TFeatureFlag = {
  name: FEATURE_FLAGS.NOTIFICATIONS,
};

export const DOCUMENTS_OFFLINE: TFeatureFlag = {
  name: FEATURE_FLAGS.DOCUMENTS_OFFLINE,
};

export const FORMS_OFFLINE: TFeatureFlag = {
  name: FEATURE_FLAGS.FORMS_OFFLINE,
};

export const VIDEO_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.VIDEO_MANAGEMENT,
};

export const DASHBOARD: TFeatureFlag = {
  name: FEATURE_FLAGS.DASHBOARD,
};

export const QUEUES: TFeatureFlag = {
  name: FEATURE_FLAGS.QUEUES,
};

export const SCHEDULER: TFeatureFlag = {
  name: FEATURE_FLAGS.SCHEDULER,
};

export const LANGUAGE: TFeatureFlag = {
  name: FEATURE_FLAGS.LANGUAGE,
};

export const NONLINEAR_WORKFLOW: TFeatureFlag = {
  name: FEATURE_FLAGS.NONLINEAR_WORKFLOW,
};

export const WORKFLOW_ROUTING: TFeatureFlag = {
  name: FEATURE_FLAGS.WORKFLOW_ROUTING,
};

export const NONLINEAR_TRAINING: TFeatureFlag = {
  name: FEATURE_FLAGS.NONLINEAR_TRAINING,
};

export const PROJECT_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.PROJECT_MANAGEMENT,
};

export const WEBHOOKS: TFeatureFlag = {
  name: FEATURE_FLAGS.WEBHOOKS,
};

export const PIN_MAP: TFeatureFlag = {
  name: FEATURE_FLAGS.PIN_MAP,
};

export const CLIMATE_API: TFeatureFlag = {
  name: FEATURE_FLAGS.CLIMATE_API,
};

export const DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT: TFeatureFlag = {
  name: FEATURE_FLAGS.DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT,
};

export const DISABLE_FORM_DUPLICATION: TFeatureFlag = {
  name: FEATURE_FLAGS.DISABLE_FORM_DUPLICATION,
};

export const ALLOW_ALL_USERS_TO_ADD_COMMENTS: TFeatureFlag = {
  name: FEATURE_FLAGS.ALLOW_ALL_USERS_TO_ADD_COMMENTS,
};

export const FLAGS_MAP: Record<FEATURE_FLAGS, TFeatureFlag> = {
  AUDIO_NOTES,
  ALLOW_ALL_USERS_TO_ADD_COMMENTS,
  DOCUMENTS,
  DOCUMENT_ACKNOWLEDGMENTS,
  JHA,
  CORRECTIVE_ACTIONS,
  FORMS,
  STANDARDS,
  CONTRACTOR_MANAGEMENT,
  EQUIPMENT_MANAGEMENT,
  SITE_MANAGEMENT,
  PEOPLE_MANAGEMENT,
  DIVISION_MANAGEMENT,
  TO_DO_LIST,
  PUBLIC_REGISTRATION,
  PUBLIC_SHARE_EQUIPMENT,
  PUBLIC_SHARE_CONTRACTORS,
  PUBLIC_SHARE_DOCUMENTS,
  PUBLIC_SHARE_JOBS,
  REPORTS,
  TRAINING_CERT,
  SYSTEM_EXPORT,
  TASKS,
  DEV_ONLY,
  NOTIFICATIONS,
  DOCUMENTS_OFFLINE,
  FORMS_OFFLINE,
  VIDEO_MANAGEMENT,
  DASHBOARD,
  QUEUES,
  SCHEDULER,
  LANGUAGE,
  NONLINEAR_WORKFLOW,
  WORKFLOW_ROUTING,
  NONLINEAR_TRAINING,
  PROJECT_MANAGEMENT,
  WEBHOOKS,
  PIN_MAP,
  CLIMATE_API,
  DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT,
  DISABLE_FORM_DUPLICATION,
};

// features that are available to all customers
// FOR NOW ALL FLAGS TO USER DEFAULT
export const defaultEnabledFeatures: TFeatureFlag[] = [
  DOCUMENTS,
  CORRECTIVE_ACTIONS,
  FORMS,
  PEOPLE_MANAGEMENT,
  TRAINING_CERT,
  TO_DO_LIST,
  PUBLIC_REGISTRATION,
  NOTIFICATIONS,
  VIDEO_MANAGEMENT,
  // DASHBOARD
  QUEUES,
  // SITE_MANAGEMENT,
  // CONTRACTOR_MANAGEMENT,
  // DIVISION_MANAGEMENT,
  // REPORTS,
  // STANDARDS,
  // JHA,
];
